import { EVENTS as E } from '../core/constants';

type BingEventParams = Record<string, string | number>;

interface BingEvent {
  action: string;
  params?: BingEventParams;
}

const BING_EVENTS_BY_ANALYTICS_EVENT: Record<string, BingEvent> = {
  [E.SESSION_START]: { action: 'ob_start' },
  [E.LEAD]: { action: 'signup' },
  [E.CHECKOUT_SHOWN]: {
    action: 'begin_checkout',
    params: { event_label: 'begin_checkout', event_category: 'begin_checkout' },
  },
};

const formatRevenueValue = (price: number) =>
  Number.isFinite(price) ? Number(price.toFixed(2)) : 0;

const formatCurrencyCode = (currency?: string) => currency?.trim().toUpperCase() || 'USD';

const pushBingEvent = ({ action, params = {} }: BingEvent) => {
  window.uetq = window.uetq || [];
  window.uetq.push('event', action, params);
};

export const sendBingFunnelEvent = (eventName: string) => {
  const bingEvent = BING_EVENTS_BY_ANALYTICS_EVENT[eventName];
  if (bingEvent) pushBingEvent(bingEvent);
};

export const sendBingPurchaseEvent = ({
  price,
  currency,
  eventId,
}: {
  price: number;
  currency?: string;
  eventId: string;
}) => {
  pushBingEvent({
    action: 'purchase',
    params: {
      event_label: 'purchase',
      event_category: 'purchase',
      revenue_value: formatRevenueValue(price),
      currency: formatCurrencyCode(currency),
      event_id: eventId,
    },
  });
};
